import { render } from "./PreviewImageModal.vue?vue&type=template&id=1fdc0dc0&scoped=true&bindings={}"
import script from "./PreviewImageModal.vue?vue&type=script&lang=ts"
export * from "./PreviewImageModal.vue?vue&type=script&lang=ts"

import "./PreviewImageModal.vue?vue&type=style&index=0&id=1fdc0dc0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1fdc0dc0"

export default script